{
  "selectCompanyStep": {
    "title": "Parlez-nous un peu plus",
    "description": "Aidez-nous à rendre votre expérience Chirpee aussi agréable que possible",
    "companyInput": {
      "label": "Quel est le nom de votre entreprise ?",
      "placeholder": "Entrez le nom de l'entreprise"
    },
    "industryInput": {
      "label": "Secteur d'activité de l'entreprise",
      "placeholder": "Sélectionnez le secteur"
    },
    "dataRegion": {
      "label": "Région des données",
      "placeholder": "Sélectionner la région des données",
      "tooltip": "Cela détermine où vos données sont stockées. Cela ne peut pas être modifié après l'inscription.",
      "us": "États-Unis",
      "eu": "Union européenne"
    },
    "nextStepButton": "Étape suivante",
    "industries": {
      "technology": "Technologie",
      "professionalServices": "Services professionnels",
      "financialServices": "Services financiers",
      "consulting": "Conseil",
      "softwareDevelopment": "Développement logiciel",
      "digitalMarketing": "Marketing numérique",
      "mediaAndCommunications": "Médias et communications",
      "eCommerce": "Commerce électronique",
      "healthTech": "Technologie de la santé"
    }
  },
  "selectLanguageStep": {
    "title": "Choisissez les langues de travail",
    "description": "Sélectionnez les langues qui seront prises en charge sur votre lieu de travail. Vous pourrez les modifier ultérieurement dans les paramètres"
  }
}
